import { render, staticRenderFns } from "./Sporadic.vue?vue&type=template&id=318ad2b8&scoped=true"
import script from "./Sporadic.vue?vue&type=script&lang=js"
export * from "./Sporadic.vue?vue&type=script&lang=js"
import style0 from "./Sporadic.vue?vue&type=style&index=0&id=318ad2b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318ad2b8",
  null
  
)

export default component.exports